import type { ChangePerformanceKitView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, useIntl } from "react-intl"
import { propertiesOf } from "src/common/property"
import type { SelectFieldProps } from "src/components/form/select/SelectField"

export interface ChangePerformanceKitForm {
	optionCode: string
}

export interface ChangePerformanceKitProps {
	option: SelectFieldProps
}

const messages = defineMessages({
	performanceKit: {
		defaultMessage: "Performance Kit",
		id: "equipment.performanceKit.title",
	},
})

const formProperties = propertiesOf<ChangePerformanceKitForm>()

export const useChangePerformanceKitProps: (props: { view: ChangePerformanceKitView }) => ChangePerformanceKitProps = ({
	view,
}) => {
	const { formatMessage } = useIntl()

	return {
		option: {
			label: formatMessage(messages.performanceKit),
			name: formProperties.optionCode._path,
			options: view.option.options.map(({ name, optionCode }) => ({
				label: name,
				value: optionCode,
			})),
			required: false,
		},
	}
}
